<div class="msp-select-container" #mspSelectContainer>
	<div
		class="select-container"
		[ngClass]="{
			disabled: disabled,
			'no-selected-options': noSelectedOptions,
		}"
		[ngStyle]="{ width: selectContainerSize }"
		(keydown.enter)="selectOption(options[highlightedOption]); collapse()"
		(keydown.arrowUp)="highlightedOption > 0 ? highlightOption(highlightedOption - 1) : null"
		(keydown.arrowDown)="highlightedOption < options.length - 1 ? highlightOption(highlightedOption + 1) : null"
		(keydown)="searchOption($event)"
		(click)="collapse()"
		tabindex="0"
		#selectContainer>
		<div>{{ displayValue }}</div>
		<fa-icon [icon]="icons.faChevronDown"></fa-icon>
	</div>
	<div class="options-container" [ngClass]="{ collapsed: collapsed }" #optionContainer>
		@for (option of options; track $index) {
			<div
				class="option"
				[ngClass]="{ highlighted: highlightedOption === $index }"
				(mousemove)="highlightOption($index)"
				(click)="selectOption(option)">
				{{ option.label }}
			</div>
		}
	</div>
</div>
